// src/auth/keycloak.js
import  KeycloakManager  from './KeycloakMan';

const env = window.env || {};

const keycloakConfig = {
  realm: 'Genera',
  url: env.KEYCLOAK_API_HOST + env.KEYCLOAK_API_PATH,
  clientId: 'genera',
  groupsKey: 'ADGroups',
};

const keycloakManager = new KeycloakManager(keycloakConfig);

export default keycloakManager;
